export type FacingMode = 'user' | 'environment';

function getConstraints(facingMode: FacingMode, quality: 'hd' | 'sd' | 'fallback'): MediaStreamConstraints {
  if (quality === 'fallback') {
    return { video: { facingMode }, audio: true };
  }

  const resolution = quality === 'hd'
    ? { width: { ideal: 1920 }, height: { ideal: 1080 } }
    : { width: { ideal: 1280 }, height: { ideal: 720 } };

  return {
    video: {
      ...resolution,
      frameRate: { ideal: 30 },
      facingMode,
    },
    audio: true,
  };
}

export async function getMediaStream(facingMode: FacingMode = 'user'): Promise<MediaStream> {
  // Try HD first
  try {
    return await navigator.mediaDevices.getUserMedia(getConstraints(facingMode, 'hd'));
  } catch (e) {
    console.log('HD capture failed, trying SD');
  }

  // Fall back to SD
  try {
    return await navigator.mediaDevices.getUserMedia(getConstraints(facingMode, 'sd'));
  } catch (e) {
    console.log('SD capture failed, trying basic');
  }

  // Last resort - basic constraints
  return navigator.mediaDevices.getUserMedia(getConstraints(facingMode, 'fallback'));
}

export async function getScreenShare(): Promise<MediaStream> {
  return navigator.mediaDevices.getDisplayMedia({
    video: {
      width: { ideal: 1920 },
      height: { ideal: 1080 },
      frameRate: { ideal: 30 },
    },
    audio: true,
  });
}
